import { render } from "./actionmodal.vue?vue&type=template&id=1dc889bc&scoped=true"
import script from "./actionmodal.vue?vue&type=script&lang=js"
export * from "./actionmodal.vue?vue&type=script&lang=js"

import "./actionmodal.vue?vue&type=style&index=0&id=1dc889bc&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dc889bc"]])

export default __exports__